import { render } from "./Parcel.vue?vue&type=template&id=2e9c3dc6"
import script from "./Parcel.vue?vue&type=script&lang=js"
export * from "./Parcel.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__